<template>
  <slot :product-titles>
    <h1
      v-if="productTitles?.subtitle && !isMasterPPUrl"
      class="mb-8 flex flex-col"
    >
      <span class="heading-1">{{ productTitles.default }}</span>
      <span class="body-2">{{ productTitles.subtitle }}</span>
    </h1>

    <h1 v-else-if="productTitles?.default" class="heading-1 mb-8">
      {{ productTitles?.default }}
    </h1>
  </slot>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

const { data: productResponse } = useFetchProduct()

const productTitles = computed(() => productResponse.value?.titles)

const { isMasterPPUrl } = useMasterPP()
</script>
